import type { IModuleDefinition, IRecord, IRecordTypeDefinition } from '@platform/core/types';
import { VIZ_FIELDS } from './vizFields';
import { VIZ_TOOLS } from './vizTools';
import { vizSourceOf } from './vizSourceOf';
import type { VisualizationKind } from './VisualizationKind';

/**
 * Діаграма запису (UIUX views/view-switcher §Visualization tab; прототип v4 vizOk): аналіз з полем «Інструмент» (Fishbone · SWOT · TOWS) —
 * fishbone причин, матриця SWOT чи TOWS з дочірніх таблиць модуля; запис із тезами в дочірній таблиці (план інтерв'ю) — брифінг.
 * Діаграма показується, лише коли модуль має відповідну дочірню таблицю. Чиста функція.
 */
export function visualizationOf(module: Pick<IModuleDefinition, 'recordTypes'>, rt: Pick<IRecordTypeDefinition, 'key' | 'fields'>, record: Pick<IRecord, 'values'>): VisualizationKind | null {
  const hasTool = rt.fields.some((f) => f.key === 'tool' && f.type === 'select');
  const tool = hasTool ? VIZ_TOOLS[String(record.values['tool'] ?? '')] : undefined;
  const kind = tool ?? (hasTool ? null : vizSourceOf(module, rt.key, VIZ_FIELDS.briefing) ? 'briefing' : null);
  return kind && vizSourceOf(module, rt.key, VIZ_FIELDS[kind]) ? kind : null;
}
